<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="transmittal?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + transmittal?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="transmittal?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${transmittal?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!transmittal?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ transmittal?.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ transmittal?.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ transmittal?.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ transmittal?.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${transmittal?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">Transmittal Record</h2>
                      </div>
                    </td>
                  </tr>
                  

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="5">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <th style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>From: {{ transmittal?.from?.full_name }}</strong></th>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">
                                        Project Management Consultant (PMC)<br>
                                        2nd Floor, Concord Bilkis Tower,<br>
                                        40/6, North Avenue (Madani Road), Gulshan-2<br>
                                        Dhaka-1212, Bangladesh
                                    </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="2">
                            <v-img
                              :src="`${getFileServerUrl}uploads/images/transmittal/transmittal1.jpg`"
                              max-width="150"
                              max-height="75"
                              contain
                            />
                          </v-col>
                          <v-col cols="5">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <th style="border: 1px solid #000; padding: 2px; width: 40%;" colspan="4"><strong>TRANSMITTAL</strong></th>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">Date:</td>
                                    <td style="border: 1px solid #000; padding: 2px;">{{ transmittal?.transmittal_date }}</td>
                                    <td style="border: 1px solid #000; padding: 2px;">Contract No.</td>
                                    <td style="border: 1px solid #000; padding: 2px;">{{ transmittal?.contact_no }}</td>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">Trans. No.:</td>
                                    <td colspan="3" style="border: 1px solid #000; padding: 2px;">{{ transmittal?.transmittal_no }}</td>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">Component</td>
                                    <td colspan="3" style="border: 1px solid #000; padding: 2px;">{{ transmittal?.component_no }}</td>
                                </tr>

                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="5">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <th style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>To: {{ transmittal?.to?.full_name }}</strong></th>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">
                                        Constractor's Representative<br>
                                        HICC-SRC-JC<br>
                                        House 117, Road 05, Block B, Niketon, Gulshan 1,<br>
                                        Dhaka-1212, Bangladesh
                                    </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="2">
                            <v-img
                              :src="`${getFileServerUrl}uploads/images/transmittal/transmittal2.png`"
                              max-width="150"
                              max-height="75"
                              contain
                            />
                          </v-col>
                          <v-col cols="5">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <th style="border: 1px solid #000; padding: 2px; width: 40%;" colspan="4"><strong>Subject:</strong></th>
                                </tr>
                                <tr>
                                    <td style="border: 1px solid #000; padding: 2px;">
                                        {{ transmittal?.subject }}
                                    </td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -10px; margin-bottom: -25px;">
                          <v-col cols="12">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 0;">
                              <strong>We are sending you the following items:</strong>
                              <span style="margin-left: 300px">Hard Copy(HC)</span>
                              <span style="margin-left: 20px">Electronically(EC)</span><br/>
                                <v-list
                                  class="folder-grid"
                                  density="compact"
                                  >
                                    <v-list-item
                                      v-for="folder in folders.slice(0, 12)"
                                      :key="folder.key"
                                      @click="active = folder.key"
                                      class="folder-item"
                                    >
                                      <v-list-item-title style="font-size: 9px;">
                                        {{ folder.name }}
                                      </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <v-row class="padding-10">
                        <v-col class="padding-0">
                            <table class="dep-table mt-5" style="width: 100%; border-collapse: collapse;">
                              <thead>
                                <tr>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Copies</th>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Drawing/Doc No.</th>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Rev.</th>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Dated</th>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Other</th>
                                  <th style="border: 1px solid #000; padding: 2px; font-size: 9px;">Description</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="row in transmittal?.details" :key="row.id">
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.copies }}</td>
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.doc_no }}</td>
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.rev }}</td>
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.date }}</td>
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.other }}</td>
                                  <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.description }}</td>
                                </tr>
                              </tbody>
                            </table>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>

                  <tr class="master-box-parent">
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row style="margin-top: -10px; margin-bottom: -25px;" class="padding-10">
                          <v-col cols="12">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 0;">
                              <strong>They are submitted for: </strong>
                              <br/>
                                <v-list
                                  class="folder-grid"
                                  density="compact"
                                  >
                                    <v-list-item
                                      v-for="folder in approvals.slice(0, 12)"
                                      :key="folder.key"
                                      @click="active = folder.key"
                                      class="folder-item"
                                    >
                                      <v-list-item-title style="font-size: 9px;">
                                        {{ folder.name }}
                                      </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row class="padding-10">
                          <v-col cols="12">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 0;">
                              <strong>Comments: </strong>
                              <br/>
                              {{ transmittal?.comment }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row  style="margin-top: -10px; margin-bottom: -25px;" class="padding-10">
                          <v-col cols="8">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 0;">
                              <strong>Via: </strong>
                              <br/>
                                <v-list
                                  class="folder-grid"
                                  density="compact"
                                  >
                                    <v-list-item
                                      v-for="folder in viaItems"
                                      :key="folder.key"
                                      @click="active = folder.key"
                                      class="folder-item"
                                    >
                                      <v-list-item-title style="font-size: 9px;">
                                        {{ folder.display_text }}
                                      </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </div>
                          </v-col>

                          <v-col cols="4">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 0;">
                             
                              <div style="padding-left:5px;margin-top: 25px;">
                                Receive By:  ____________________________
                              </div>

                              <div style="padding-left:5px;margin-top:25px;margin-bottom:57px">
                                Date:  ____________________________
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <!-- <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot> -->
              </table>
            </div>
            <!-- <div class="invoice-footer">
              <img v-if="transmittal?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${transmittal?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;">
            </div> -->
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import formattedDate from "@/plugins/dateFormatter";
import axios from 'axios';
import { prefix } from '@/store/api';

const getCmsFoldersList = prefix + 'cms/folders'

const route = useRoute();
const router = useRouter();
const store = useStore();

const id = route.params.id;
const transmittal = ref(null);
const invoiceHeader = ref(true);
const pagePadding = ref(0);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

const formattedAdvancePayment = computed(() => {
  if (!transmittal.value) return '';
  const value = transmittal.value.advance_payment_value || 0;
  const type = transmittal.value.advance_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const formattedBalancePayment = computed(() => {
  if (!transmittal.value) return '';
  const value = transmittal.value.before_shipment_payment_value || 0;
  const type = transmittal.value.before_shipment_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const folders = ref([]);

const approvals = ref([
  {key: 'approval', name: 'Approval'},
  {key: 'field_user', name: 'Field Use'},
  {key: 'checking', name: 'Checking'},
  {key: 'others', name: 'Others'},
  {key: 'final_approval', name: 'Final Approval'},
  {key: 'purchase', name: 'Purchase'},
  {key: 'pricing', name: 'Pricing'},
  {key: 'field_measurements', name: 'Field Measurements'},
  {key: 'preliminary_only', name: 'Preliminary Only'},
  {key: 'reproduction', name: 'Reproduction'},
  {key: 'information', name: 'Information'},
  {key: 'fabrication', name: 'Fabrication'},
  {key: 'your_use', name: 'Your Use'}
]);

const viaItems = [
  {value: 'ups-courier', display_text: 'UPS/Courier'},
  {value: 'mdsc-transport', display_text: 'MDSC Transport'},
  {value: 'hand-carry', display_text: 'Hand Carry'},
  {value: 'email', display_text: 'Email'},
]

const formatNumber = (val) => {
  if (val == null || val === "") return "";
  return Number(val).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Transmittal Record</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 10px;
          padding: 0;
        }
  
        html, body {
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        .details-table {
          padding: 0px 25px;
          padding-left: 20px;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
        
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
          padding: 0px 30px;
          justify-content:space-between;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 12px 6px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }

        .v-col-xxl, .v-col-xxl-auto, .v-col-xxl-12, .v-col-xxl-11, .v-col-xxl-10, .v-col-xxl-9, .v-col-xxl-8, .v-col-xxl-7, .v-col-xxl-6, .v-col-xxl-5, .v-col-xxl-4, .v-col-xxl-3, .v-col-xxl-2, .v-col-xxl-1, .v-col-xl, .v-col-xl-auto, .v-col-xl-12, .v-col-xl-11, .v-col-xl-10, .v-col-xl-9, .v-col-xl-8, .v-col-xl-7, .v-col-xl-6, .v-col-xl-5, .v-col-xl-4, .v-col-xl-3, .v-col-xl-2, .v-col-xl-1, .v-col-lg, .v-col-lg-auto, .v-col-lg-12, .v-col-lg-11, .v-col-lg-10, .v-col-lg-9, .v-col-lg-8, .v-col-lg-7, .v-col-lg-6, .v-col-lg-5, .v-col-lg-4, .v-col-lg-3, .v-col-lg-2, .v-col-lg-1, .v-col-md, .v-col-md-auto, .v-col-md-12, .v-col-md-11, .v-col-md-10, .v-col-md-9, .v-col-md-8, .v-col-md-7, .v-col-md-6, .v-col-md-5, .v-col-md-4, .v-col-md-3, .v-col-md-2, .v-col-md-1, .v-col-sm, .v-col-sm-auto, .v-col-sm-12, .v-col-sm-11, .v-col-sm-10, .v-col-sm-9, .v-col-sm-8, .v-col-sm-7, .v-col-sm-6, .v-col-sm-5, .v-col-sm-4, .v-col-sm-3, .v-col-sm-2, .v-col-sm-1, .v-col, .v-col-auto, .v-col-12, .v-col-11, .v-col-10, .v-col-9, .v-col-8, .v-col-7, .v-col-6, .v-col-5, .v-col-4, .v-col-3, .v-col-2, .v-col-1 {
          width: 100%;
          padding: 12px;
        }

        .folder-grid[data-v-aa8545d8] {
          display: grid;
          grid-auto-flow: column;
          grid-template-rows: repeat(3, auto);
          gap: 0px 16px;
          max-width: 100%;
        }
        .v-theme--light {
          color-scheme: normal;
          --v-theme-background: 255,255,255;
          --v-theme-surface: 255,255,255;
          --v-theme-on-background: 0,0,0;
          --v-theme-on-surface: 0,0,0;
          --v-border-color: 0, 0, 0;
          --v-border-opacity: 0.12;
          --v-high-emphasis-opacity: 0.87;
        }
        .v-list {
          background: rgba(var(--v-theme-surface));
          color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
        }
        .v-list {
          border-radius: 0;
        }
        .v-list {
          box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
        }
        .v-list {
          border-color: rgba(var(--v-border-color), var(--v-border-opacity));
          border-style: solid;
          border-width: 0;
        }
        .v-list {
          overflow: auto;
          padding: 8px 0;
          position: relative;
          outline: none;
        }
        .v-list {
          --indent-padding: 0px;
        }

        .v-row {
            display: flex;
            flex-wrap: wrap;
            flex: 1 1 auto;
            margin: -12px;
            padding: 0px 30px;
          }
          .v-col {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
          }
          .v-col-4 {
            flex: 0 0 33.3333333333%;
            max-width: 33.3333333333%;
          }
          .v-col-5 {
            flex: 0 0 41.6666666667%;
            max-width: 41.6666666667%;
          }
          .v-col-8 {
            flex: 0 0 66.6666666667%;
            max-width: 66.6666666667%;
          }
          .v-col-12 {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .mt-5 {
            margin-top: 20px !important;
          }

          .padding-10{
            padding: 10px !important; 
          }
          .padding-0{
            padding: 0px !important;
          }

        @media print { 
          .v-row {
            display: flex;
            flex-wrap: wrap;
            flex: 1 1 auto;
            margin: -12px;
            padding: 0px 30px;
          }
          .v-col {
            flex-basis: 0;
            flex-grow: 1;
            max-width: 100%;
          }
          .v-col-4 {
            flex: 0 0 33.3333333333%;
            max-width: 33.3333333333%;
          }
          .v-col-5 {
            flex: 0 0 41.6666666667%;
            max-width: 41.6666666667%;
          }
          .v-col-8 {
            flex: 0 0 66.6666666667%;
            max-width: 66.6666666667%;
          }
          .v-col-12 {
            flex: 0 0 100%;
            max-width: 100%;
          }
          .mt-5 {
            margin-top: 20px !important;
          }
          .padding-10{
            padding: 10px !important; 
          }


        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.focus();
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(async () => { 
  try {
    const res = await store.dispatch("getCmsTransmittalById", id);
    
    if (res?.data?.success) {
      transmittal.value = res.data.data;
    } else {
      console.error("API returned unsuccessful response:", res);
    }
  } catch (error) {
      console.error("Error fetching sales contact:", error);
  }

  axios.get(getCmsFoldersList, { params: { all: true } })
    .then((response) => {
      if (response.data.success) {
        folders.value = response.data.data || [];
      } else {
        folders.value = [];
      }
    })
    .catch((error) => {
      folders.value = [];
    })

});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.folder-grid {
  display: grid;
  grid-auto-flow: column;   /* fill top → bottom, then next column */
  grid-template-rows: repeat(3, auto); /* 3 items per column */
  gap: 0px 16px;            /* row gap | column gap */
  max-width: 100%;
}

.folder-item {
  cursor: pointer;
  min-width: 120px; /* optional: control column width */
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
